module.exports = (__webpack_require__(0))(27);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/widgets/HierarchyWidget.js from dll-reference girder_lib
// module id = 42
// module chunks = 0